import {
  Box, Button, Grid, Link,
} from '@mui/material';
import { useMemo, useState } from 'react';
import BlockComponentButton, { ButtonSizeMap } from '../../models/BlockComponentValues/BlockComponentButton';
import BlockData from '../../models/BlockData';
import { URLOpenType } from '../../models/URLOpenType';
import { URLTargetType } from '../../models/URLTargetType';
import LinkModal from '../Modals/LinkModal';
import ButtonSettingsModal from '../Modals/ButtonSettingsModal/ButtonSettingsModal';
import { ColorPickerColors, ColorPickerColorsMap } from '../../models/ColorPicker';

interface LinkButtonProps {
  button: BlockComponentButton;
  isEditable: boolean;
  isTemplate?: boolean;
  blockData: BlockData[];
  updateHandler: (item: any) => void;
}

function LinkButton({
  isEditable,
  isTemplate,
  button,
  blockData,
  updateHandler,
}: LinkButtonProps) {
  const [openLinkModal, setOpenLinkModal] = useState(false);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [item, setItem] = useState(button);
  const [error, setError] = useState('');

  const buttonStyle = useMemo(() => {
    const style = {
      width: ButtonSizeMap[button.settings.size],
      backgroundColor: ColorPickerColorsMap[button.settings.color as ColorPickerColors] || button.settings.color,
      padding: '1.05rem',
    };

    return style;
  }, [button]);

  const handleOpenLinkModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenLinkModal(true);
    event.stopPropagation();
  };
  const handleOpenSettingsModal = (event: React.MouseEvent<HTMLDivElement>) => {
    setOpenSettingsModal(true);
    event.stopPropagation();
  };

  const handleCloseLinkModal = (event: React.MouseEvent) => {
    setError('');
    setItem(button);
    setOpenLinkModal(false);
    event.stopPropagation();
  };
  const handleCloseSettingsModal = (event: React.MouseEvent) => {
    setError('');
    setItem(button);
    setOpenSettingsModal(false);
    event.stopPropagation();
  };

  const handleSaveLinkModal = () => {
    if (!item.link.title) {
      setError('タイトルを入力してください');
    } else {
      setError('');
      updateHandler(item);
      setOpenLinkModal(false);
    }
  };
  const handleSaveSettingsModal = () => {
    setError('');
    updateHandler(item);
    setOpenSettingsModal(false);
  };

  if (!isEditable && !isTemplate) {
    return (
      <Box>
        <Grid
          container
          justifyContent={button.settings.justify || 'center'}
          alignItems="center"
          sx={{
            padding: 1,
          }}
        >
          <Link sx={{ width: '100%', display: 'flex', justifyContent: 'center' }} href={button.link.linkData.url} target={button.link.linkData.openType} rel="noreferrer" underline="none">
            <Button className="Button-More" style={buttonStyle} size={button.settings.size}>
              {button.link.title}
            </Button>
          </Link>
        </Grid>
      </Box>
    );
  }

  if (!isEditable && isTemplate) {
    return (
      <Box>
        <Grid
          container
          justifyContent={button.settings.justify || 'center'}
          sx={{
            padding: 1,
          }}
        >
          <Button className="Button-More" style={buttonStyle} size={button.settings.size}>
            {button.link.title}
          </Button>
        </Grid>
      </Box>
    );
  }

  return (
    <Box onClick={(event) => event.stopPropagation()}>
      <Grid
        container
        justifyContent={button.settings.justify || 'center'}
        sx={{
          padding: 1,
        }}
        onClick={(event) => handleOpenSettingsModal(event)}
      >
        <Button
          className="Button-More"
          onClick={(event) => handleOpenLinkModal(event)}
          style={buttonStyle}
          size={button.settings.size}
        >
          {button.link.title}
        </Button>
      </Grid>

      <LinkModal
        openModal={openLinkModal}
        onCloseModal={(event) => handleCloseLinkModal(event)}
        onSaveModal={handleSaveLinkModal}
        link={item.link}
        errorText={error}
        blockData={blockData}
        hideRemoveButton
        onChangeURLTitle={(newTitle) => { setItem({ ...item, link: { ...item.link, title: newTitle } }); }}
        onChangeTargetType={(newTargetType) => {
          if (newTargetType === URLTargetType.INTERNAL) {
            setItem({ ...item, link: { ...item.link, linkData: { ...item.link.linkData, targetType: newTargetType, openType: URLOpenType.SAME_PAGE } } });
          } else {
            setItem({ ...item, link: { ...item.link, linkData: { ...item.link.linkData, targetType: newTargetType } } });
          }
        }}
        onSelectBlock={(selected) => { setItem({ ...item, link: { ...item.link, linkData: { ...item.link.linkData, url: selected } } }); }}
        onChangeLink={(newLink) => { setItem({ ...item, link: { ...item.link, linkData: { ...item.link.linkData, url: newLink } } }); }}
        onChangeOpenType={(checked) => { setItem({ ...item, link: { ...item.link, linkData: { ...item.link.linkData, openType: checked ? URLOpenType.NEW_TAB : URLOpenType.SAME_PAGE } } }); }}
      />

      <ButtonSettingsModal
        openModal={openSettingsModal}
        onCloseModal={handleCloseSettingsModal}
        onSaveModal={handleSaveSettingsModal}
        onChangeSize={(newSize) => { setItem({ ...item, settings: { ...item.settings, size: newSize } }); }}
        onChangeColor={(newColor) => { setItem({ ...item, settings: { ...item.settings, color: newColor } }); }}
        settings={item.settings}
      />

    </Box>
  );
}

export default LinkButton;
